import React from "react";
import {Button,Col,Container,Form, Row } from "react-bootstrap";
import logo from "../../../assets/images/logo.png";
import google from "../../../assets/images/icons/google.svg";
import fb_icon from "../../../assets/images/icons/fb_icon.svg";
import { NavLink } from "react-router-dom";

function ForgotPasswordComponent(){
    return(
        <>
            
            <div className="text-center">
                <NavLink to="/" className="navbar-brand">
                    <img loading="lazy"  src={logo} />
                </NavLink>
            </div>
            <div className="d-flex align-items-center justify-content-center my-4">
                <h1 className="fs-36 fw-400 m-0">Forgot Password?</h1> 
            </div>
            <p className="text-center fs-16 fw-400">Enter your Email ID</p>
            <Form>
                <Form.Group className="mb-4" controlId="formBasicEmail">
                    <Form.Label className="fs-16 fw-400">Email</Form.Label>
                    <Form.Control className="fs-16 fw-400" type="email" placeholder="Example@email.com" />
                </Form.Group>

                <div className="d-grid mb-4">
                    <Button variant="warning" type="submit">Get Code</Button>
                </div>
            </Form>  
  
        </>
    )
}

export default ForgotPasswordComponent;